import React from "react";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import ImageRoundedIcon from "@mui/icons-material/ImageRounded";

export default function PendingAssetField({
  label,
  file,
  onChange,
  helperText = "",
  accept = "image/svg+xml,image/jpeg,image/png,image/webp,image/avif,image/gif,image/x-icon,.svg,.ico",
  disabled = false,
}) {
  const inputRef = React.useRef(null);
  const [previewUrl, setPreviewUrl] = React.useState("");

  React.useEffect(() => {
    if (!file) {
      setPreviewUrl("");
      return undefined;
    }

    const nextUrl = URL.createObjectURL(file);
    setPreviewUrl(nextUrl);
    return () => URL.revokeObjectURL(nextUrl);
  }, [file]);

  const handleFile = (event) => {
    const selected = event.target.files?.[0] || null;
    event.target.value = "";
    if (selected) onChange(selected);
  };

  return (
    <Stack spacing={0.75}>
      <Typography variant="body2" sx={{ fontWeight: 900, color: "rgba(25,36,47,.78)" }}>
        {label}
      </Typography>
      <Paper
        variant="outlined"
        sx={{
          p: 1,
          borderRadius: 2.5,
          borderStyle: "dashed",
          bgcolor: "rgba(25,36,47,.018)",
        }}
      >
        <Stack direction="row" spacing={1.2} alignItems="center">
          <Box
            sx={{
              width: 66,
              height: 54,
              flex: "0 0 auto",
              borderRadius: 2,
              overflow: "hidden",
              bgcolor: "rgba(25,36,47,.08)",
              display: "grid",
              placeItems: "center",
            }}
          >
            {previewUrl ? (
              <Box component="img" src={previewUrl} alt={label} sx={{ width: "100%", height: "100%", objectFit: "contain" }} />
            ) : (
              <ImageRoundedIcon sx={{ color: "rgba(25,36,47,.38)" }} />
            )}
          </Box>

          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography variant="body2" noWrap sx={{ fontWeight: 850 }}>
              {file?.name || "Opcional"}
            </Typography>
            {helperText ? (
              <Typography variant="caption" sx={{ color: "rgba(25,36,47,.58)", display: "block", mt: 0.2 }}>
                {helperText}
              </Typography>
            ) : null}
            <Stack direction="row" spacing={0.6} sx={{ mt: 0.75 }}>
              <Button
                type="button"
                size="small"
                variant="outlined"
                startIcon={<CloudUploadRoundedIcon />}
                disabled={disabled}
                onClick={() => inputRef.current?.click()}
                sx={{ textTransform: "none", fontWeight: 900, borderRadius: 999 }}
              >
                {file ? "Cambiar" : "Elegir"}
              </Button>
              {file ? (
                <IconButton type="button" size="small" disabled={disabled} onClick={() => onChange(null)} aria-label={`Quitar ${label}`}>
                  <DeleteOutlineRoundedIcon fontSize="small" />
                </IconButton>
              ) : null}
            </Stack>
          </Box>
        </Stack>
      </Paper>
      <input ref={inputRef} type="file" hidden accept={accept} onChange={handleFile} />
    </Stack>
  );
}
